import { render, staticRenderFns } from "./AnalyseModal.vue?vue&type=template&id=ed20b890&scoped=true"
import script from "./AnalyseModal.vue?vue&type=script&lang=js"
export * from "./AnalyseModal.vue?vue&type=script&lang=js"
import style0 from "./AnalyseModal.vue?vue&type=style&index=0&id=ed20b890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed20b890",
  null
  
)

export default component.exports